import { Reducer } from 'redux';
import { WidgetActionType } from '../actions';
import { WidgetSetConfigPayload } from './actions';
import mergeWith from 'lodash/mergeWith';
import cloneDeep from 'lodash/cloneDeep';
import isArray from 'lodash/isArray';
import { Action } from 'store/store';

export function createConfigurationReducer<T>(
    initialState: T,
    /*
     *If supplied, the postReducer will be run after the generic config reducer...
     */
    postReducer?: Reducer<T, Action<string, Partial<WidgetSetConfigPayload<T>>>>
): Reducer<T, Action<string, Partial<WidgetSetConfigPayload<T>>>> {
    return (state = initialState, action) => {
        const nextState = genericConfigReducer(initialState, state, action);
        return postReducer ? postReducer(nextState, action) : nextState;
    };
}

function genericConfigReducer<T>(
    initialState: T,
    state: T,
    action: Action<string, Partial<WidgetSetConfigPayload<T>>>
): T {
    if (!action.payload || !action.payload.configDelta) {
        return state;
    }
    switch (action.type) {
        case WidgetActionType.WIDGET_SET_CONFIG:
            if (action.payload.replace) {
                return { ...initialState, ...action.payload!.configDelta };
            }
            return { ...state, ...action.payload!.configDelta };
        case WidgetActionType.WIDGET_LOAD_CONFIG:
            return mergeWith(
                cloneDeep(initialState),
                action.payload!.configDelta,
                (defaultVal, loadedVal) =>
                    isArray(defaultVal) ? loadedVal : undefined
            );

        default:
            return state;
    }
}
